/* eslint-disable react-hooks/exhaustive-deps */
import AddIcon from "@mui/icons-material/Add";
import { LoadingButton } from "@mui/lab";
import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import AddPlanModal from "../../components/Modals/AddPlan";
import CancelModal from "../../components/Modals/Cancel";
import SearchBar from "../../components/SearchBar";
import Table from "../../components/table/Table";
import {
  closeModal,
  getEmployees,
  setPagination,
  setPayload,
} from "../../features/company/employeeSlice";
import UseEmployee from "../../hooks/UseEmployee";
import HomeLayout from "../../layouts/Home";
import config from "../../utils/config";
import { getAmount } from "../../utils/helper";

const { routes } = config;
const Employees = () => {
  const {
    plans,
    data,
    dropdownMenu,
    pagination,
    loading,
    modal,
    model,
    name,
    cancelHmoPlan,
    addHmoPlan,
    handleDelete,
    dispatch,
  } = UseEmployee();

  return (
    <HomeLayout {...{ title: "Employee" }}>
      <Box data-cy="employee-dashboard-page">
        <Box className="flex justify-between flex-col gap-6 sm:flex-col lg:flex-col xl:flex-row">
          <SearchBar
            {...{
              placeholder: "Search by Employee Name...",
              onChange: (e) => {
                const { value } = e.target;
                if (e.code === "Enter") dispatch(getEmployees(value));
                else dispatch(setPagination({ search: value }));
              },
            }}
            data-cy="search-input"
          />
          <Box className="flex justify-between gap-4 sm:flex-col lg:flex-row flex-col">
            <LoadingButton
              LinkComponent={Link}
              className="w-[220px] h-[56px] bg-[var(--c-gray-4)] text-[var(--c-primary-0)] text-[18px] rounded-xl shadow-none normal-case"
              size="small"
              type="submit"
              variant="contained"
              fullWidth
              to={routes.companies.employees.upload}
              data-cy="upload-employees-btn"
            >
              Upload Employees
            </LoadingButton>
            <LoadingButton
              LinkComponent={Link}
              className="w-[213px] h-[56px] bg-[var(--c-primary-0)] text-[600] text-[18px] rounded-xl shadow-none normal-case"
              size="small"
              type="submit"
              variant="contained"
              fullWidth
              startIcon={<AddIcon />}
              to={routes.companies.employees.new}
              data-cy="add-employee-btn"
            >
              Add Employee
            </LoadingButton>
          </Box>
        </Box>
        <Box
          className="pt-8 px-8 mt-14 pb-2 bg-[var(--c-bg-color)] rounded-lg w-100%"
          sx={{ p: 0 }}
        >
          <Table
            {...{
              dropdownMenu,
              data,
              pagination,
              setPagination: (d) => dispatch(setPagination(d())),
              isLoading: loading,
            }}
          />

          <CancelModal
            {...{
              open: modal.cancelPlan,
              loading: modal.loading,
              title: "Cancel Plan",
              subtitle: `Are you sure you want to cancel ${name}'s plan?`,
              btnTexts: ["No", "Yes"],
              handleSuccess: cancelHmoPlan,
              handleClose: (_) => dispatch(closeModal("cancelPlan")),
            }}
          />
          <CancelModal
            {...{
              open: modal.delete,
              loading: modal.loading,
              title: "Delete Employee",
              subtitle: `Are you sure you want to delete ${name}?`,
              btnTexts: ["Cancel", "Delete"],
              handleSuccess: handleDelete,
              handleClose: (_) => dispatch(closeModal("delete")),
            }}
          />
          <AddPlanModal
            {...{
              open: modal.addPlan,
              loading: modal.loading,
              title: "Add Plan",
              value: model.hmoPlan,
              setValue: (val) => dispatch(setPayload({ hmoPlan: val })),
              options: plans?.map(({ Plan, planId }) => {
                return Plan.name + " - ₦" + getAmount(Plan.amount);
              }),
              subtitle: `Please select the H.M.O plan to be added `,
              btnTexts: ["Cancel", "Add Plan"],
              handleSuccess: addHmoPlan,
              handleClose: (_) => dispatch(closeModal("addPlan")),
            }}
          />
        </Box>
      </Box>
    </HomeLayout>
  );
};

export default Employees;
